export default __webpack_public_path__ + "static/media/navbar-logo.731d2084.png";